
import { create } from 'zustand';
import { User } from '../services/authService';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  /**
   * True once the app has checked the stored token on first load (profile
   * fetched, or the token discarded). Route guards wait for this instead of
   * bouncing a signed-in user to /login while the profile request is in flight.
   */
  bootstrapped: boolean;
  setUser: (user: User | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  setBootstrapped: (done: boolean) => void;
  clearUser: () => void;
}

const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,
  bootstrapped: false,

  setUser: (user) => set({ user, error: null, bootstrapped: true }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setBootstrapped: (bootstrapped) => set({ bootstrapped }),
  clearUser: () => set({ user: null, error: null }),
}));

export default useAuthStore;
